import { render, staticRenderFns } from "./SimpelbangStats.vue?vue&type=template&id=3f521e6f&scoped=true&"
import script from "./SimpelbangStats.vue?vue&type=script&lang=js&"
export * from "./SimpelbangStats.vue?vue&type=script&lang=js&"
import style0 from "./SimpelbangStats.vue?vue&type=style&index=0&id=3f521e6f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f521e6f",
  null
  
)

export default component.exports